export default __webpack_public_path__ + "static/media/306.cc83106d.gif";